import React from "react";

export const Avatar = ({ className = "", children, ...props }) => {
  return (
    <div className={`relative inline-block ${className}`} {...props}>
      {children}
    </div>
  );
};

export const AvatarImage = ({ src, alt, className = "", ...props }) => {
  return (
    <img
      src={src}
      alt={alt}
      className={`h-full w-full object-cover rounded-full ${className}`}
      {...props}
    />
  );
};

export const AvatarFallback = ({ className = "", children, ...props }) => {
  return (
    <div
      className={`h-full w-full rounded-full bg-gradient-to-r from-logo to-[#6720A3] flex items-center justify-center text-white font-bold ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};
